import { useMemo } from 'react'
import {
  useHrmsAttendanceSettings,
  apiTimeToForm,
} from './useHrmsAttendanceSettings'
import type { AttendanceStatusConfig } from '../utils/manualAttendanceStatus.utils'

export interface UseAttendanceStatusConfigResult {
  config: AttendanceStatusConfig | undefined
  isLoading: boolean
  isError: boolean
}

/**
 * Shared hook to derive AttendanceStatusConfig from HRMS attendance settings.
 * Reuses the existing useHrmsAttendanceSettings query and cached data.
 */
export function useAttendanceStatusConfig(): UseAttendanceStatusConfigResult {
  const { data: settingsData, isLoading, isError } = useHrmsAttendanceSettings()

  const config: AttendanceStatusConfig | undefined = useMemo(() => {
    if (!settingsData) return undefined
    return {
      workStartTime: apiTimeToForm(settingsData.workStartTime),
      workEndTime: apiTimeToForm(settingsData.workEndTime),
      graceMinutes: settingsData.arrivalGracePeriodMins ?? 15,
      halfDayThresholdMinutes: settingsData.halfDayThresholdMins ?? 240,
      dailyWorkingHours: settingsData.dailyWorkingHours ?? 8,
    }
  }, [settingsData])

  return {
    config,
    isLoading,
    isError,
  }
}
